import React, { useEffect, useState } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

// ✅ AJOUT : format FR pour dates (JJ/MM/AAAA)
function formatDateFR(raw) {
  if (!raw) return "";
  const dt = new Date(raw);
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleDateString("fr-FR");
}

export default function DemandeDetail({ demande, onBack, onAssigned }) {
  const [selectedOperateur, setSelectedOperateur] = useState(
    demande?.operateur || ""
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setSelectedOperateur(demande?.operateur || "");
  }, [demande]);

  if (!demande) return <p>Aucune donnée disponible</p>;

  const saveOperateur = async (operateurLabel) => {
    setError("");
    setSaving(true);

    try {
      // On stocke en MAJUSCULE pour matcher les pages opérateurs (AMEL, LAMIA, etc.)
      const operateur = (operateurLabel || "").trim().toUpperCase();

      const res = await fetch(
        `${API}/api/demandes/${demande._id}/operateur`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ operateur }),
        }
      );

      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || "Erreur sauvegarde");
      }

      // ✅ refresh liste accueil (et retour)
      if (onAssigned) onAssigned();
      if (onBack) onBack();
    } catch (e) {
      console.error(e);
      setError("Impossible d’enregistrer l’opérateur.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Détails de la demande</h2>

      <p>
        <strong>Nom :</strong> {demande.nom_naissance}
      </p>
      <p>
        <strong>Prénom :</strong> {demande.prenom}
      </p>
      <p>
        <strong>Date de naissance :</strong> {formatDateFR(demande.date_naissance)}
      </p>
      <p>
        <strong>Nb personnes :</strong> {demande.nb_pers_a_heberger}
      </p>
      <p>
        <strong>Travailleur social :</strong> {demande.nom_prenom_ts1}
      </p>
      <p>
        <strong>Email TS :</strong> {demande.courriel_ts1}
      </p>
      <p>
        <strong>Date 1ère transmission SIAO :</strong>{" "}
        {formatDateFR(demande.date_premiere_transmission)}
      </p>

      <div style={{ marginTop: 20 }}>
        <label>
          <strong>Opératrice/Opérateur :</strong>
        </label>
        <br />
        <select
          value={selectedOperateur}
          onChange={(e) => {
            const op = e.target.value;
            setSelectedOperateur(op);
            if (op) saveOperateur(op);
          }}
          disabled={saving}
          style={{ padding: 8, marginTop: 8, width: 260 }}
        >
          <option value="">-- Choisir --</option>
          <option value="Lamia">Lamia</option>
          <option value="Claudia">Claudia</option>
          <option value="Amel">Amel</option>
          <option value="Solenne">Solenne</option>
          <option value="Elissa">Elissa</option>
          <option value="Morgan">Morgan</option>
        </select>
      </div>

      {error ? <p style={{ color: "red", marginTop: 10 }}>{error}</p> : null}

      <button
        onClick={onBack}
        style={{
          marginTop: 30,
          padding: "10px 20px",
          backgroundColor: "#1976d2",
          color: "white",
          border: "none",
          borderRadius: 5,
          cursor: "pointer",
        }}
      >
        Retour
      </button>
    </div>
  );
}
